<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <h1 class="title-default">Notas recebidas</h1>
        <p class="welcome-message">NF-e e CT-e emitidos contra as empresas do grupo, capturados da SEFAZ</p>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button type="button" class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          <span
            [matTooltip]="'Selecione ao menos uma nota na listagem'"
            [matTooltipDisabled]="selection.hasValue()">
            <button mat-menu-item type="button" (click)="baixarNotasSelecionadas($event)" [disabled]="!selection.hasValue()">
              @if (isLoadingDownload) {
                <mat-spinner diameter="20" class="me-3"></mat-spinner>
              } @else {
                <mat-icon class="material-symbols-outlined">download</mat-icon>
              }
              <span>Baixar notas selecionadas</span>
            </button>
          </span>
          <button mat-menu-item type="button" (click)="fazerPedidoExtracao(tipoExtracaoEnum.NotaRecebidaXml)">
            <mat-icon class="material-symbols-outlined">collections_bookmark</mat-icon>
            <span>Baixar XML de todas as notas do filtro</span>
          </button>
          <button mat-menu-item type="button" (click)="fazerPedidoExtracao(tipoExtracaoEnum.NotaRecebidaCsv)">
            <mat-icon class="material-symbols-outlined">description</mat-icon>
            <span>Baixar CSV da tabela</span>
          </button>
          <button mat-menu-item type="button" (click)="abrirModalHistoricoBusca()">
            <mat-icon class="material-symbols-outlined">history</mat-icon>
            <span>Histórico de buscas Sefaz</span>
          </button>
        </mat-menu>
      </div>
    </div>

    @if (!isLoadingInitialData) {
      <app-alert-card
        [type]="isBuscaAutomatica ? 'info' : 'neutral'"
        [icon]="isBuscaAutomatica ? 'sync' : 'sync_disabled'"
        [title]="isBuscaAutomatica ? 'Busca automática: Ativada' : 'Busca automática: Desativada'">
        @if (controleAcessoSefazNFe?.datetimeUltimoAcesso || controleAcessoSefazCTe?.datetimeUltimoAcesso) {
          Última busca feita na Sefaz:
          <ul class="ultimas-buscas">
            @for (item of [{ modelo: 'NF-e', controle: controleAcessoSefazNFe }, { modelo: 'CT-e', controle: controleAcessoSefazCTe }]; track item.modelo) {
              <li>
                <strong>{{ item.modelo }}:</strong>
                @if (item.controle?.datetimeUltimoAcesso) {
                  {{ item.controle?.datetimeUltimoAcesso | date: "dd/MM/yyyy 'às' HH:mm:ss" }}
                  @if (item.controle?.isBloqueadoPorConsumoIndevido) {
                    <span class="proxima-busca">- bloqueada pela Sefaz por consumo indevido até {{ item.controle?.datetimeLiberacaoBuscaManual | date: 'HH:mm' }}</span>
                  } @else if (item.controle?.datetimeLiberacaoBuscaManual) {
                    <span class="proxima-busca">- próxima busca a partir de {{ item.controle?.datetimeLiberacaoBuscaManual | date: 'HH:mm' }}</span>
                  }
                } @else {
                  nenhuma busca registrada
                }
              </li>
            }
          </ul>
        } @else {
          Nenhuma busca na Sefaz registrada até o momento.
        }
        <div alertActions>
          <button mat-stroked-button type="button" class="btn-secondary" (click)="abrirConfiguracoes()">
            <mat-icon class="material-symbols-outlined">settings</mat-icon>
            Configurações
          </button>
        </div>
      </app-alert-card>
    }

    @if (!isLoadingInitialData && (showAlertCard || showSefazError)) {
      <app-alert-card-timed [type]="'warning'" [closable]="true" [timerDuration]="20000" (close)="closeAlertCard()">
        @if (showAlertCard) {
          <h4 class="alert-title"><strong>Atenção! Certificado Inválido</strong></h4>
          @if (isSingleCompanyView) {
            <p>A sua empresa está sem um certificado A1 válido cadastrado e, por isso, não terá suas notas fiscais
              atualizadas automaticamente.</p>
            <p>Navegue até seu módulo Fiscal e verifique o cadastro do seu certificado!</p>
          } @else {
            <p>As seguintes empresas não possuem um certificado digital A1 válido cadastrado e, por isso, não terão suas
              notas fiscais atualizadas automaticamente.</p>
            <ul>
              @for (empresa of empresasSemCertificado; track empresa.idEmpresa) {
                <li>{{ empresa.nomeEmpresa }}</li>
              }
            </ul>
          }
        }

        @if (showSefazError) {
          @if (showAlertCard) {
            <hr class="alert-divider">
          }
          <h4 class="alert-title"><strong>Rejeição 656: Consumo Indevido</strong></h4>
          <p>{{ mensagemErroSefaz }}</p>
        }
      </app-alert-card-timed>
    }

    <form [formGroup]="filterForm" (ngSubmit)="aplicarFiltros()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input
              matInput
              type="text"
              formControlName="pesquisar"
              placeholder="Pesquisar nº da nota, emitente, destinatário ou CPF/CNPJ" />
            <button
              mat-icon-button
              matSuffix
              type="submit"
              class="icon-mat-symbols-btn"
              aria-label="Pesquisar">
              <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button
            #periodoMenuTrigger="matMenuTrigger"
            mat-stroked-button
            type="button"
            class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu"
            [class.btn-periodo--ativo]="periodoSelecionado !== periodoEnum.DoMes">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu">
            <div class="periodo-menu-content">
              @for (opcao of opcoesPeriodo; track opcao.periodo) {
                <button
                  type="button"
                  class="periodo-menu-item"
                  [class.periodo-item-selecionado]="periodoSelecionado === opcao.periodo"
                  (click)="selecionarPeriodo(opcao.periodo, $event)">
                  <span>{{ opcao.rotulo }}</span>
                  @if (periodoSelecionado === opcao.periodo) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
              }

              @if (periodoSelecionado === periodoEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerDe"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataDe')"
                      formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDe></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerAte"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataAte')"
                      formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAte></mat-datepicker>
                    @if (filterForm.get('dataAte')?.hasError('dataInvalida')) {
                      <mat-error>Data final menor que a inicial</mat-error>
                    }
                    @if (filterForm.get('dataAte')?.hasError('intervaloExcedido')) {
                      <mat-error>Intervalo máx. de {{ limiteMeses }} meses</mat-error>
                    }
                  </mat-form-field>
                  <div class="periodo-intervalo-actions">
                    <button
                      type="button"
                      mat-button
                      class="btn-secondary"
                      (click)="cancelarIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button
                      type="button"
                      mat-flat-button
                      class="btn-primary"
                      (click)="aplicarIntervalo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
              }
            </div>
          </mat-menu>

          <button
            mat-stroked-button
            type="button"
            class="btn-filter"
            [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="filterForm">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros</h6>
                <div class="filter-menu__form">
                  <app-select-pesquisavel
                    label="Modelo do documento"
                    [control]="$any(filterForm.get('tiposNota'))"
                    [idField]="'idModeloDocumento'"
                    [nameField]="'nome'"
                    [subtitleFields]="['descricao']"
                    [offlineList]="listaModeloDocumento"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione os modelos">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Destinatário"
                    [control]="$any(filterForm.get('listIdEmpresa'))"
                    [idField]="'idEmpresa'"
                    [nameField]="'nomeEmpresa'"
                    [subtitleFields]="['cnpj']"
                    [offlineList]="listaEmpresas"
                    [multiple]="true"
                    [isOptional]="true"
                    [hint]="
                      isSingleCompanyView
                        ? 'Filtro travado: o grupo tem uma única empresa'
                        : 'Sem seleção, considera todas as empresas do grupo'
                    ">
                  </app-select-pesquisavel>

                  <mat-form-field appearance="outline">
                    <mat-label>Série</mat-label>
                    <input matInput type="text" formControlName="serie" mask="000" [validation]="false" inputmode="numeric" maxlength="3" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>CFOP</mat-label>
                    <input matInput type="text" formControlName="cfop" [mask]="masks.cfop" [validation]="false" inputmode="numeric" />
                    <button mat-icon-button matSuffix type="button" class="icon-mat-symbols-btn"
                        aria-label="Pesquisar CFOP" [disabled]="filterForm.get('cfop')?.disabled"
                        (click)="$event.stopPropagation(); pesquisarCfop()">
                        <mat-icon>search</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button type="button" class="btn-secondary" matMenuClose>Cancelar</button>
                <button
                  mat-flat-button
                  type="button"
                  class="btn-primary"
                  (click)="aplicarFiltros()"
                  matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (dataSource.data.length > 0) {
      <div class="table-container desktop-view">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
              <mat-checkbox
                (change)="toggleAllRows()"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="selection.toggle(row)"
                [checked]="selection.isSelected(row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="tipoNota">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Modelo</th>
            <td mat-cell *matCellDef="let row">{{ row.modeloDocumento }}</td>
          </ng-container>

          <ng-container matColumnDef="numeroNota">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nota / Série</th>
            <td mat-cell *matCellDef="let row">{{ row.numeroSerie }}</td>
          </ng-container>

          <ng-container matColumnDef="dataHoraEmissao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Emissão</th>
            <td mat-cell *matCellDef="let row">{{ row.emissao | date: 'dd/MM/yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="cfop">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CFOP</th>
            <td mat-cell *matCellDef="let row">{{ (row.cfop || '') | mask: '0.000' : { patterns: cfopMaskPatterns } }}</td>
          </ng-container>

          <ng-container matColumnDef="emitente">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Emitente</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="row.emitente">
              <span class="truncate-cell">{{ row.emitente }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="destinatario">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinatário</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="row.destinatario">
              <span class="truncate-cell">{{ row.destinatario }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor (R$)</th>
            <td mat-cell *matCellDef="let row" class="text-end nota-valor-cell">{{ row.valor || 0 | abnt: 'preco' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-badge" [ngClass]="classeBadgeStatus(row)" [matTooltip]="obterDescricaoSituacaoDocumento(row)">
                {{ obterDescricaoSituacaoDocumento(row) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center w-actions">
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="row.isLoading || row.isLoadingDanfe"
                [matMenuTriggerFor]="menu"
                [disabled]="row.isLoading || row.isLoadingDanfe"
                [attr.aria-label]="row.isLoading || row.isLoadingDanfe ? 'Executando ação da nota' : 'Ações da nota'">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (row.isLoading || row.isLoadingDanfe) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menu="matMenu">
                <span [matTooltip]="tooltipVisualizarPdf(row)" [matTooltipDisabled]="podeVisualizarPdf(row)">
                  <button mat-menu-item type="button" [disabled]="!podeVisualizarPdf(row)" (click)="visualizarPdf(row)">
                    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                    <span>Visualizar PDF</span>
                  </button>
                </span>
                <span [matTooltip]="'XML não disponível para esta nota'" [matTooltipDisabled]="!!row.xmlPath">
                  <button mat-menu-item type="button" [disabled]="!row.xmlPath" (click)="baixarXml(row)">
                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                    <span>Baixar XML</span>
                  </button>
                </span>
                <span [matTooltip]="'Detalhes disponíveis apenas para NF-e e CT-e'" [matTooltipDisabled]="podeVerDetalhes(row)">
                  <button mat-menu-item type="button" [disabled]="!podeVerDetalhes(row)" (click)="verDetalhes(row)">
                    <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
                    <span>Detalhes da nota</span>
                  </button>
                </span>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="mobile-view">
        @for (row of dataSource.data; track row.origemDocumentoFiscalRecebido + '-' + row.idModeloDocumento + '-' + row.idDFeRecebido) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (change)="selection.toggle(row)"
                  [checked]="selection.isSelected(row)"
                  color="primary"></mat-checkbox>
                <div class="d-flex flex-column">
                  <span class="text-bold">{{ row.modeloDocumento }} {{ row.numeroSerie }}</span>
                  <small>{{ row.emissao | date: 'dd/MM/yyyy HH:mm' }}</small>
                </div>
              </div>
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="row.isLoading || row.isLoadingDanfe"
                [matMenuTriggerFor]="menuMobile"
                [disabled]="row.isLoading || row.isLoadingDanfe"
                [attr.aria-label]="row.isLoading || row.isLoadingDanfe ? 'Executando ação da nota' : 'Ações da nota'">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (row.isLoading || row.isLoadingDanfe) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menuMobile="matMenu">
                <span [matTooltip]="tooltipVisualizarPdf(row)" [matTooltipDisabled]="podeVisualizarPdf(row)">
                  <button mat-menu-item type="button" [disabled]="!podeVisualizarPdf(row)" (click)="visualizarPdf(row)">
                    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                    <span>Visualizar PDF</span>
                  </button>
                </span>
                <span [matTooltip]="'XML não disponível para esta nota'" [matTooltipDisabled]="!!row.xmlPath">
                  <button mat-menu-item type="button" [disabled]="!row.xmlPath" (click)="baixarXml(row)">
                    <mat-icon class="material-symbols-outlined">download</mat-icon>
                    <span>Baixar XML</span>
                  </button>
                </span>
                <span [matTooltip]="'Detalhes disponíveis apenas para NF-e e CT-e'" [matTooltipDisabled]="podeVerDetalhes(row)">
                  <button mat-menu-item type="button" [disabled]="!podeVerDetalhes(row)" (click)="verDetalhes(row)">
                    <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
                    <span>Detalhes da nota</span>
                  </button>
                </span>
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <div class="row">
                <div class="col-12 mb-2">
                  <small class="d-block">Emitente</small>
                  <span class="truncate-cell">{{ row.emitente }}</span>
                </div>
                <div class="col-12 mb-2">
                  <small class="d-block">Destinatário</small>
                  <span class="truncate-cell">{{ row.destinatario }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">CFOP</small>
                  <span>{{ (row.cfop || '') | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Valor (R$)</small>
                  <span class="text-bold">{{ row.valor || 0 | abnt: 'preco' : 2 }}</span>
                </div>
                <div class="col-12">
                  <small class="d-block">Status</small>
                  <span class="status-badge" [ngClass]="classeBadgeStatus(row)">{{ obterDescricaoSituacaoDocumento(row) }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="text-center load-more"
        [matTooltip]="ultimaPagina ? 'Todas as notas foram carregadas' : isLoading ? 'Carregando notas' : ''">
        <button mat-button type="button" (click)="proximaPagina()" [disabled]="isLoading || ultimaPagina">
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">keyboard_arrow_down</span>
            Ver mais
          }
        </button>
      </div>
    } @else if (isLoading || isLoadingInitialData) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
      <app-empty-list
        title="Nenhuma nota encontrada"
        [subTitle]="
          empresasSemCertificado.length > 0
            ? 'A busca automática de notas só funciona para empresas com Certificado A1 válido. Verifique o alerta acima.'
            : !isBuscaAutomatica
              ? 'A busca automática está desativada. Acesse Configurações e ative essa função para automatizar a busca de notas.'
              : 'Tente alterar o período ou os filtros de busca'
        "></app-empty-list>
    }
  </div>
</div>

<!-- Rodapé de totalização: padrão global .footer-totals. -->
<div class="footer-totals">
  <div class="footer-totals-inner">
    <div class="footer-totals-item footer-totals-item--total">
      <span class="footer-totals-label">Valor total (R$)</span>
      <span class="footer-totals-value">{{ valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      <span>{{ dataSource.data.length }} de {{ fullListSize }} notas</span>
    </div>
  </div>
</div>
<div class="footer-totals-height-fake"></div>

<button
  class="btn-footer-totals-mobile"
  type="button"
  (click)="toggleGavetaMobile()"
  aria-label="Abrir resumo das notas">
  <span class="material-symbols-outlined">analytics</span>
</button>

@if (isMobileDrawerOpen) {
  <div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
  <div class="footer-totals-mobile-sheet__header modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h3 class="modal-title">Resumo das notas</h3>
    </div>
    <div class="modal-header-close-btn-container">
      <button
        mat-icon-button
        type="button"
        class="modal-close-btn icon-mat-symbols-btn"
        (click)="fecharGavetaMobile()"
        aria-label="Fechar resumo das notas">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__content">
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total footer-totals-mobile-sheet__item--full">
      <span class="footer-totals-mobile-sheet__label">VALOR TOTAL (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__footer">
    <span class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      {{ dataSource.data.length }} de {{ fullListSize }} notas
    </span>
  </div>
</div>
